<template>
	<div class="MAM_riskControlLogList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<!-- <el-form-item style="width:187px;">
                    <el-radio v-model="searchForm.team_type" :label="1" @change="typeChange">团队交易</el-radio>
                    <el-radio v-model="searchForm.team_type" :label="2" @change="typeChange">直营交易</el-radio>
                </el-form-item> -->
				<el-form-item>
					<el-select v-model="searchForm.type" clearable placeholder="请选择规则名称">
						<el-option label="伪激活扣款规则" value="1"></el-option>
						<el-option label="未激活扣款规则" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="searchForm.brand_id" filterable clearable style="width:100%"
						placeholder="请选择终端类型">
						<el-option v-for="(item,index) in brandList" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input clearable v-model="searchForm.terminal_sn" placeholder="请输入SN"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input clearable v-model="searchForm.merchant_number" placeholder="请输入商户编号"></el-input>
				</el-form-item>
				<el-form-item v-if="agentNoState">
					<el-input clearable v-model="searchForm.agent_no" placeholder="请输入代理商编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="searchForm.is_deal" clearable placeholder="请选择扣款状态">
						<el-option label="未完成" value="1"></el-option>
						<el-option label="已完成" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker v-model="rangeDate" type="daterange" range-separator="至" start-placeholder="触发开始日期"
						end-placeholder="触发结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(searchForm)">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-download" :loading="downLoading"
						@click="handleDownLoad">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="riskControlLogList" size="mini" border style="width: 100%" v-loading="loading"
				max-height="500px">
				<el-table-column header-align="center" align="center" fixed prop="id" label="ID" min-width="80">
				</el-table-column>
        <el-table-column header-align="center" align="center" prop="terminal_sn" label="SN号" min-width="150">
        </el-table-column>
				<el-table-column header-align="center" align="center" prop="brand_name" label="终端类型" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="control_type_text" label="规则名称"
					min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="order_num" label="处罚单号" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_name" label="商户名称" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_number" label="商户编号"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="所属代理商名称" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="所属代理商编号" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="所属代理商手机号" min-width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
              <p>{{ scope.row.phone | desMobile }}</p>
            </el-tooltip>
          </template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="deduction_amount" label="处罚金额(元)"
					min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="had_money" label="已扣款金额(元)"
					min-width="200">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="not_money" label="未扣款金额(元)" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="is_deal_text" label="扣款状态" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="扣款触发时间" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="complete_time" label="扣款完成时间"
					min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="infoList(scope.row)" type="text" size="small">详情</el-button>
						<!-- <el-button v-if="scope.row.status == 0" @click="handleSkip(scope.row)" type="text" size="small">
							核销</el-button>
						<div v-else>--</div> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
		<!-- 审核&详情 -->
		<deduction-detail
		        v-if="detailIsShow"
		        :detailIsShow="detailIsShow"
		        :dialogData="dialogData"
		        @infoClose="infoClose"
		></deduction-detail>
	</div>
</template>

<script>
	import deductionDetail from './FM_details';
	export default {
		name: "MAM_riskControlLogList",
		data() {
			return {
				agentNoState:true,
				currentDate: '',
				pickerOptions: {},
				rangeDate: [], //时间范围
				brandList: [], //终端类型
				ruleList: [], //规则类型
				searchForm: {
					page: 1,
					limit: 10,
					type: '', //规则类型
					brand_id: '', //终端类型
					terminal_sn: '', //SN
					real_name: '', //SN归属人姓名
					phone: '', //SN归属人手机号
					status: '', //扣款状态 0失败 1成功
					start_time: '', //触发开始日期
					end_time: '', //触发结束日期
					team_type: 1,
				},
				riskControlLogList: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: true,
				downLoading: false, //导出loading
				detailIsShow: false, //查看详情弹窗
				dialogData: {
				    data: {} //当前行的数据
				},
			}
		},
		components: {
		    deductionDetail,
		},
		created() {
			
			if(sessionStorage.getItem('agent_no')){
				this.agentNoState = false;
				this.searchForm.agent_no = sessionStorage.getItem('agent_no');
			}
			
			this.pickerOptions.disabledDate = (time) => { //禁用日期
				if (this.currentDate !== '') {
					let tempTime = 3600 * 1000 * 24 * 30;
					let timer = new Date(this.currentDate).getTime();
					let minTime = timer - tempTime;
					let maxTime = timer + tempTime;
					return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
				}
				return time.getTime() > Date.now();
			}
			this.pickerOptions.onPick = ({
				minDate,
				maxDate
			}) => { //当前选中的日期
				this.currentDate = minDate.getTime();
				if (maxDate) {
					this.currentDate = '';
				}
			}
		},
		mounted() {
			// this.handleDefaultTime();
			this.getBrand(); //获取终端类型
			this.getRule(); //获取规则类型
			this.getData(this.searchForm)
		},
		methods: {
			onSearch(searchForm) { //搜索
				this.currentPage = 1;
				searchForm.page = 1;
				this.getData(searchForm);
			},
			typeChange(val) { //监听radio
				this.searchForm.team_type = val;
				this.currentPage = 1; //重置分页
				this.searchForm.page = 1; //重置
				// 表单提交
				this.getData(this.searchForm);
			},
			handleSkip(row) { //编辑
				this.$confirm('核销后，将扣除所属代理的剩余扣款钱包对应的金额，扣款状态更新为扣款成功。', '提示', {
					confirmButtonText: '确 认',
					cancelButtonText: '取 消',
					closeOnClickModal: false,
					type: 'warning',
					beforeClose: (action, instance, done) => {
						if (action == 'confirm') {
							instance.confirmButtonLoading = true;
							this.$api.post('brand_risk_control/deal_brand_risk_control_trigger', {
								id: row.id
							}, res => {
								if (res.code == 0) {
									this.$message.success(res.msg);
									this.loading = true;
									this.getData(this.searchForm);
									done();
								} else {
									this.$message.error(res.msg);
									instance.confirmButtonLoading = false;
								}
							})
						} else {
							done();
						}
					}
				}).then(() => {}).catch(() => {});
			},
			// 分页部分
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			getData(params) { //获取数据
				this.loading = true;
				this.$api.post("brand_risk_control/get_brand_risk_control_trigger_list", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.total = data.count; //总数
						this.riskControlLogList = data.list;
						//渲染结束后取消加载
						this.loading = false;
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			getBrand() { //获取终端类型
				this.$api.post('brand/brand_list', {}, res => {
					if (res.code == 0) {
						this.brandList = res.data.list;
					} else {
						this.$message.success(res.msg);
					}
				});
			},
			getRule() { //获取规则类型
				this.$api.post('get_risk_control', {}, res => {
					if (res.code == 0) {
						this.ruleList = res.data;
					} else {
						this.$message.success(res.msg);
					}
				});
			},
			pickerChange(DateArr) { //时间选择器
				this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			// handleDefaultTime() { //默认获取三十天
			//     let date = new Date().getTime();
			//     this.searchForm.end_time = this.$moment().format("YYYY-MM-DD");
			//     this.searchForm.start_time = this.$moment(date - 3600 * 1000 * 24 * 30).format("YYYY-MM-DD");
			//     this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
			// },
			handleDownLoad() { //导出
				let reqData = {
					type: 8,
					value: JSON.stringify(this.searchForm)
				};
				
				this.downLoading = true; 
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
				})
			},
			infoClose(ref) {
			    this.detailIsShow = false;
			    if (ref) {
			        this.getData(this.searchForm);//刷新
			    }
			},
			infoList(row) { //查看处罚详情
				this.$api.post("brand_risk_control/get_brand_risk_control_trigger_log_list", {id:row.id}, res => {
					if (res.code == 0) {
						this.dialogData.data = res.data;
						this.detailIsShow = true;
					} else {
						this.$message.error(res.msg);
					}
				})
			},
		}
	};
</script>

<style lang="scss" scope>
	.MAM_riskControlLogList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.el-popover__title {
			font-size: 12px;
			font-weight: 700;
		}
	}
</style>
